import React, { Component, useState } from "react";
import KickImage from 'Reuseables/KickImage';
import { Row, Col, Modal, ModalBody } from "reactstrap";
import moment from "moment";
import styled from "styled-components";

import Button from "../../Forms/Button";
import { EmptyTableWrapper, EmptyVoucher as EmptyVoucherStyle } from "../../../reusablestyled";
import { formatCurrency, getCloudImageUrl } from "../../../utils";

/* COMPONENT */
import VoucherCard from "./VoucherCard"

// ASSETS
import CloseIcon from "../../../images/close-button-search.png";
import TukTuk from "../../../images/truck-tuk-tuk.png";
import EmptyVoucher from "../../../images/no-voucher.png";
import CloseButton from "../../../images/close30.png";
import DefaultThumbnailRebrand from "../../../images/voucher/thumbnail.png";
import DefaultBannerRebrand from "../../../images/voucher/banner.png";

// const DEFAULT_THUMBNAIL_VOUCHER = "https://kickavenue-assets.s3.amazonaws.com/assets-image/default_voucher.jpg";
// const DEFAULT_BANNER_VOUCHER = "https://kickavenue-assets.s3.amazonaws.com/assets-image/default_voucher_banner.jpg";

const UserVoucher = ({ dataList, onClick, onRefresh, currency, ratio }) => {
  const [isOpen, setIsOpen] = useState(false);
  const toggleModalDetail = () => {
    setIsOpen(!isOpen);
  };
  const [detailVoucher, setDetailVoucher] = useState(null);
  const [copySuccess, setCopySuccess] = useState("Copy");

  const useImageVoucher = (type, images) => {
    let img = "";

    images.forEach((e) => {
      e.orientation == type && (img = e.URL);
    });
    return img;
  };

  const detailsModal = () => {
    return detailVoucher ? (
      <Modal
        isOpen={isOpen}
        toggle={toggleModalDetail}
        className="voucher-code-wrapper"
      >
        <KickImage
          onClick={() => {
            setIsOpen(!isOpen);
            setCopySuccess("Copy");
          }}
          src={CloseButton} className="close-rounded-btn" />
        <div className="voucher-code-modal-header">
          <div className="header-content-wrapper">
            <p>VOUCHER DETAIL</p>
            <div
              className="close-icon-container"
              style={{ cursor: "pointer" }}
              onClick={() => {
                setIsOpen(!isOpen);
                setCopySuccess("Copy");
              }}
            >
              <KickImage src={CloseIcon} alt="close-icon" />
            </div>
          </div>
        </div>
        <ModalBody className="voucher-code-details-wrapper">
          <div className="header-details">
            <div className="tuk-tuk-wrapper">
              {detailVoucher?.voucher?.images?.length > 0 ? (
                <KickImage
                  src={getCloudImageUrl(useImageVoucher("landscape", detailVoucher?.voucher?.images), 900)}
                  alt="..."
                  className="truck-icon"
                />
              ) : (
                <KickImage src={DefaultBannerRebrand} alt="..." className="truck-icon" />
              )}
            </div>
          </div>
          <div className="voucher-info-container">
            <div className="voucher-info-wrapper">
              <p className="voucher-info-title">{detailVoucher?.voucher?.name}</p>
              <div
                className="voucher-info-date"
                style={{ flexDirection: "column" }}
              >
                <div
                  className="first-info"
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <p>Minimum purchase</p>
                  <p>
                    {formatCurrency(detailVoucher?.voucher?.minimum_purchase, ratio, currency)}
                  </p>
                </div>
                <div
                  className="second-info"
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    flexDirection: "row",
                  }}
                >
                  <p>Valid until</p>
                  <p>
                      {detailVoucher?.voucher?.ended_at
                        ? moment(detailVoucher?.voucher?.ended_at).format("MMM D, YYYY")
                        : detailVoucher?.ended_at? moment(detailVoucher?.ended_at).format("MMM D, YYYY") : "forever"}
                  </p>
                </div>
              </div>
              <div className="info-field-wrapper">
                <p>
                  Voucher code: <span>{detailVoucher?.voucher?.code}</span>
                </p>
                <p
                  onClick={() => {
                    navigator.clipboard.writeText(detailVoucher?.voucher?.code);
                    setCopySuccess("Copied");
                  }}
                  style={{ cursor: "pointer" }}
                >
                  {copySuccess}
                </p>
              </div>
            </div>
          </div>
          {(detailVoucher?.description && detailVoucher?.terms) && <div className="voucher-description-term-condition-outside-wrapper">
            <div className="voucher-description-term-condition-inside-wrapper voucher-dashboard-tpo">
              {detailVoucher?.description && <div className="voucher-description-wrapper">
                <p>Description</p>
                <p
                  dangerouslySetInnerHTML={{
                    __html: detailVoucher?.voucher?.description,
                  }}
                />
              </div>}
              {detailVoucher?.terms && <div className="voucher-term-condition-wrapper">
                <p>Terms and Condition</p>
                <div
                  className="list-term-condition-wrapper"
                  dangerouslySetInnerHTML={{
                    __html: detailVoucher?.voucher?.terms,
                  }}
                />
              </div>}
            </div>
          </div>}
        </ModalBody>
      </Modal>
    ) : null;
  };
  if (dataList.data.length === 0 && !dataList.isFetching) {
    return (
      <EmptyVoucherStyle>
        <div className="image-wrapper">
          <KickImage src={EmptyVoucher} alt="empty-voucher" />
        </div>
        <div className="text">
          <p>No voucher found.</p>
          <p>You can find an ongoing promotions at our instagram @kick.avenue or by regularly shopping at Kick Avenue.</p>
        </div>
        <button
          onClick={(e) => onRefresh(e, 1)}
          className="refresh-button">
          <p>Refresh</p>
        </button>
      </EmptyVoucherStyle>
    );
  } else {
    return (
      <Row className="dashboard-voucher-container">
        {dataList.data.map((item, index) => {
          const validUntilText = item.voucher.ended_at
            ? moment(item.voucher.ended_at).format("MMM D, YYYY")
            : item.ended_at ? moment(item.ended_at).format("MMM D, YYYY") : "forever";

          const minPurchase = formatCurrency(item.voucher.minimum_purchase, ratio, currency);

          const image = item.voucher.images.length > 0
            ?
            getCloudImageUrl(useImageVoucher("portrait", item.voucher.images), 200)
            :
            DefaultThumbnailRebrand
          return (
            <>
              {/* <div className="voucher-list">
                <div className="top-content">
                  <div className="tuk-tuk-wrapper">
                    {item.voucher.images.length > 0 ? (
                      <KickImage
                        src={getCloudImageUrl(useImageVoucher("portrait", item.voucher.images), 200)}
                        alt="..."
                      />
                    ) : (
                      <KickImage src={getCloudImageUrl(DEFAULT_THUMBNAIL_VOUCHER, 200)} alt="..." />
                    )}
                  </div>
                  <div className="top-content-info">
                    <p>{item.voucher.name}</p>
                    <p>
                      Min purchase {formatCurrency(item.voucher.minimum_purchase)}
                    </p>
                    <p>
                      Valid until{" "}
                      {item.voucher.ended_at
                        ? moment(item.voucher.ended_at).format("MMM D, YYYY")
                        : item.ended_at ? moment(item.ended_at).format("MMM D, YYYY") : "forever"}
                    </p>
                  </div>
                </div>
                <div className="bottom-content">
                  <p>
                    Voucher Code:{" "}
                    <span className="bottom-content-voucher">
                      {item.voucher.code}
                    </span>
                  </p>
                  <p
                    onClick={() => {
                      setIsOpen(!isOpen);
                      setDetailVoucher(item.voucher);
                    }}
                  >
                    <i>View detail</i>
                  </p>
                </div>
              </div> */}
              <VoucherCard
                openModalDetail={() => {
                  setIsOpen(!isOpen);
                  setDetailVoucher(item);
                }}
                voucherName={item.voucher.name}
                item={item}
                minPurchase={minPurchase}
                validUntilText={validUntilText}
                setDetailVoucher={setDetailVoucher}
                bottomLeft={"Promo Code"}
                bottomRight={item.voucher.code}
                image={image}
              />
            </>
          );
        })}
        {detailsModal()}
      </Row>
    );
  }
};

export default UserVoucher;
